var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.notification && _vm.notification.message && _vm.notification.message.length)?_c('div',[_c('b-alert',{attrs:{"show":"","dismissible":"","variant":_vm.typeClass}},[_c('p',{staticClass:"m-0"},[_vm._v(_vm._s(_vm.notification.message))])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }